import { SCOPE_KIND_META, scopeKindChipLabel, summarizeScopeKinds } from '../lib/scopeKinds.js';

interface ScopeSummaryProps {
  scopes: readonly string[];
}

/**
 * Compact, read-only scope display for table cells: a one-glance breakdown by
 * kind ("1 access · 1 assistant · 5 data") instead of an opaque "N scopes".
 * Each segment carries its kind dot; the full sorted list is one hover away
 * (native title tooltip), so cells stay fixed-width as scopes accumulate.
 */
export const ScopeSummary = ({ scopes }: ScopeSummaryProps) => {
  if (scopes.length === 0) {
    return <span className="text-xs text-ink-subtle">—</span>;
  }

  const segments = summarizeScopeKinds(scopes);
  const tooltip = [...scopes].sort().join('\n');

  return (
    <span
      title={tooltip}
      className="inline-flex cursor-default items-center divide-x divide-outline overflow-hidden rounded-md border border-outline text-[11px] font-semibold text-ink"
    >
      {segments.map(({ kind, count }) => (
        <span key={kind} className="flex items-center gap-1.5 px-2 py-1">
          <span
            className={`h-1.5 w-1.5 rounded-sm ${SCOPE_KIND_META[kind].dotClass}`}
            aria-hidden
          />
          {scopeKindChipLabel(kind, count)}
        </span>
      ))}
    </span>
  );
};
